// extracted by mini-css-extract-plugin
module.exports = {"phoneFieldParent":"sign-up_phoneFieldParent__3LsjK","disclaimer":"sign-up_disclaimer__1yxYE","resendHeader":"sign-up_resendHeader__Lcx1-"};